import React from "react";
import WhatsaApp from "../../../../assets/icons/whatsapp.png";
import { Link } from "react-router";
const FloatingWhatsapp = () => {
  return (
    <div className="fixed bottom-28 lg:bottom-16 right-2 lg:right-10 ">
      <Link to={"https://wa.me/+881321144864"} target="_blank">
        <div className="w-full h-12 lg:h-16 cursor-pointer scale-100 hover:scale-110 duration-300">
          <p className="text-nowrap text-xs lg:text-sm bg-white rounded-full px-3 py-1 border border-slate-100 text-center">
            Customized Tour?
          </p>
          <img
            src={WhatsaApp}
            alt=""
            className="w-full h-full object-contain"
          />
        </div>
      </Link>
    </div>
  );
};

export default FloatingWhatsapp;
